module.exports = __webpack_public_path__ + "static/media/boy_dance_nt.0b62a976.gif";